module.exports = __webpack_public_path__ + "assets/img/dog.48d610b4.jpg";